import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import Calendar from 'components/Calendar/Calendar.react';
import { Directions } from 'lib/Constants';
import Icon from 'components/Icon/Icon.react';
import { monthDayStringUTC, monthsFrom, daysFrom } from 'lib/DateUtils';
import Popover from 'components/Popover/Popover.react';
import moment from 'moment';
import Position from 'lib/Position';
import PropTypes from 'prop-types';
import styles from './ChromeDateRange.scss';

export default class ChromeDateRange extends Component {
  constructor(props) {
    super();

    const val = props.value || {};

    this.state = {
      open: false,
      position: null,
      start: val.start || monthsFrom(new Date(), -1),
      end: val.end || new Date(),
    };

    this.tags = React.createRef();

    this.changeRange = this.changeRange.bind(this);
  }

  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }

  setEnd(end) {
    let start = this.state.start;
    if (start > end) {
      start = daysFrom(end, -1);
    }

    this.removeTagsActiveClass();
    this.setState({ start, end });
    this.props.onChange({ start, end });
  }

  setStart(start) {
    let end = this.state.end;
    if (start > end) {
      end = daysFrom(start, 1);
    }

    this.removeTagsActiveClass();
    this.setState({ start, end });
    this.props.onChange({ start, end });
  }

  close() {
    this.setState({ open: false });
    // this.props.onChange({ start: this.state.start, end: this.state.end });
  }

  rangeString() {
    return (
      `${moment(this.state.start).format('MMM DD')} - ${moment(this.state.end).format('MMM DD')}`
    );
  }

  toggle() {
    this.setState((state) => {
      if (this.state.open) {
        return { open: false };
      }
      const pos = Position.inWindow(this.node);
      if (this.props.align === Directions.RIGHT) {
        pos.x += this.node.clientWidth;
      }
      return {
        open: true,
        position: pos,
      };
    });
  }

  removeTagsActiveClass = () => {
    const activeElements = this.tags.current.getElementsByClassName(styles.active);
    if (activeElements.length > 0) {
      for (const item of activeElements) {
        item.classList.remove(styles.active);
      }
    }
  }

  changeRange = (e, format) => {
    const fromDate = () => {
      const d = format ? moment().subtract(format[0], format[1]) : moment();
      d.set({
        hour: 0, minute: 0, second: 0, millisecond: 0,
      });
      return d.toDate();
    };

    const toDate = moment().toDate();


    this.removeTagsActiveClass();

    e.target.classList.add(styles.active);

    this.setState({
      start: fromDate(),
      end: toDate,
    });

    this.props.onChange({
      start: fromDate(),
      end: toDate,
    });
  };

  render() {
    let popover = null;
    let content = null;
    if (this.state.open) {
      const classes = [styles.open];
      if (this.props.align === Directions.RIGHT) {
        classes.push(styles.right);
      }
      if (this.props.align === Directions.BOTTOM_RIGHT) {
        classes.push(styles.bottomRight);
      }
      const renderShade = (
        this.state.start.getFullYear() < this.state.end.getFullYear() ||
        this.state.start.getMonth() !== this.state.end.getMonth()
      );

      popover = (
        <Popover fixed position={this.state.position} onExternalClick={this.close.bind(this)}>
          <div className={classes.join(' ')}>
            <div className={styles.calendars}>
              <div className={styles.predefined} ref={this.tags}>
                <div onClick={e => this.changeRange(e)}>Today</div>
                <div onClick={e => this.changeRange(e, [7, 'days'])}>Last 7 days</div>
                <div onClick={e => this.changeRange(e, [14, 'days'])}>Last 14 days</div>
                <div onClick={e => this.changeRange(e, [1, 'month'])}>Last Month</div>
              </div>
              <div className={styles.pickers}>
                <Calendar
                  value={this.state.start}
                  selectedDays={this.state.end}
                  onChange={start => this.setStart(start)}
                  shadeAfter
                  range={this.props.range || [1, 'years', new Date()]} />
                <Calendar
                  value={this.state.end}
                  shadeBefore
                  onChange={end => this.setEnd(end)}
                  range={this.props.range || [1, 'years', new Date()]} />
              </div>
            </div>
            <div className={styles.range} onClick={this.close.bind(this)}>
              <Icon name="icon-calendar" width={18} height={18} colored />
              <span>{this.rangeString()}</span>
            </div>
          </div>
        </Popover>
      );
    } else {
      content = (
        <Fragment>
          <Icon name="icon-calendar" width={18} height={18} colored />
          <span>{this.rangeString()}</span>
        </Fragment>
      );
    }

    return (
      <div className={styles.wrap} onClick={this.toggle.bind(this)}>
        <div className={styles.range}>
          {content}
          {popover}
        </div>
      </div>
    );
  }
}
